<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          v-model="dateRangeText"
          label="Selecione o período"
          prepend-inner-icon="mdi-calendar"
          readonly
          outlined
          dense
          v-bind="attrs"
          v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="dates"
        range
        no-title
        scrollable
        locale="pt-br"
        @change="onDateChange"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { ref, computed, watch } from 'vue';

export default {
  name: 'AppRangeDate',
  props: {
    value: {
      type: Object,
      default: () => ({ start: null, end: null }),
    },
  },
  setup(props, { emit }) {
    const menu = ref(false);

    // O v-date-picker com 'range' usa um array de duas datas.
    const dates = ref([props.value.start, props.value.end]);

    // Formata a data para o padrão DD/MM/YYYY
    const formatDate = (dateString) => {
      if (!dateString) return null;
      // Adiciona verificação para o caso da data já estar formatada
      if (dateString.includes('/')) return dateString;
      const [year, month, day] = dateString.split('-');
      return `${day}/${month}/${year}`;
    };

    // Cria o texto a ser exibido no campo, ex: "01/07/2024 ~ 15/07/2024"
    const dateRangeText = computed(() => {
      const [start, end] = dates.value;
      if (start && end) {
        const formattedStart = formatDate(start);
        const formattedEnd = formatDate(end);
        // Garante que a data menor venha primeiro no texto
        return new Date(start) < new Date(end)
          ? `${formattedStart} ~ ${formattedEnd}`
          : `${formattedEnd} ~ ${formattedStart}`;
      }
      return '';
    });

    // Função chamada pelo evento @change do date-picker
    const onDateChange = (newDates) => {
      // O evento @change só é disparado quando o intervalo está completo (2 datas)
      if (newDates.length === 2) {
        // Garante a ordem correta antes de emitir
        const start = newDates[0] < newDates[1] ? newDates[0] : newDates[1];
        const end = newDates[0] > newDates[1] ? newDates[0] : newDates[1];

        emit('input', { start, end });
        menu.value = false; // Fecha o menu
      }
    };

    // Observa mudanças na prop 'value' para atualizar o componente de fora
    watch(() => props.value, (newValue) => {
      dates.value = [newValue.start, newValue.end];
    }, { deep: true });

    return {
      menu,
      dates,
      dateRangeText,
      onDateChange,
    };
  },
};
</script>

<style scoped>
/* Estilos podem ser adicionados aqui se necessário */
</style>
